import store from '@/store'
import Process from '@/models/Process';
import Realisation from '@/models/Realisation';
import ProcessesConfig from '@/components/Table/configs/ProcessesConfig';
import { realisationListFields } from '@/config';

let mappedProcesses = []
const counts = {
  current: 0,
  total: 0
}

const isRVB = process.env.VUE_APP_TENANT === 'rvb'

export function mapProcesses ({ processType, processes }) {

  const records = processes.map(process => {
    const isRealisationType = process.processType.value === 'realisation'
    const ProcessType = isRealisationType ? Realisation : Process

    return new ProcessType({ data: process, ref: process._id })
  })

  if (!processType) {
    store.dispatch('realisations/setRecords', { records })
  }
  const mappedRecords = records.map(ProcessesConfig.dataMapper).slice();
  const formattedRecords = mappedRecords.map(record => realisationListFields({ record }))
  mappedProcesses = [...mappedProcesses, ...formattedRecords]

  return formattedRecords
}

export function clearTempProcesses () {
  mappedProcesses = []
}

export async function setSelectedProcess (data) {
  store.dispatch('processes/setSelectedProcess', {
    process: new Process({ data, ref: null, newProcess: true })
  })
}

export async function fetchBaseAssetProcess ({ token, locationId, processType }) {
  // Check asset process type (manual, imported...) //
  let response = await fetchAssetByLocationId ({ token, locationId })
  const manualOrImportType = response.asset.baseType !== 'realisation' // manual, import //

  let data;

  if (!manualOrImportType) {
    const api = await fetch('/api/process', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        locationId
      })
    }).catch(err => console.log(err))

    if (!api.ok) {
      throw new Error('Getting realisation failed! ')
    }

    response = await api.json()

    data = setDataFromRealisationProcess(response, processType)
  } else {
    data = setDataFromAsset(response.asset, processType)
  }

  store.dispatch('processes/setSelectedProcess', {
    process: new Process({ data, ref: null, newProcess: true })
  })
}

export async function getProcessByUuid ({ token, uuid, useClass = true, setSelected = true }) {
  const api = await fetch('/api/process', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      uuid
    })
  }).catch(err => console.log(err))

  if (!api.ok) {
    throw new Error('Getting process failed! ')
  }

  const response = await api.json()

  const process = response.data.record
  if (process.deleted_at) {
    return {
      errorMessage: 'Process does not exist!'
    }
  }

  if (setSelected) {
    if (process.processType.value !== 'realisation') {
      store.dispatch('processes/setSelectedProcess', {
        process: useClass
          ? new Process({ data: process, ref: process._id })
          : process
      })
    } else {
      store.dispatch('processes/setRecordData', { process })
    }
  }

  return process
}

export async function fetchProcessesByType ({ token, processType, code, bbox, after }) {

  if (!isRVB) {
    mappedProcesses = []
  }
  //store.dispatch('realisations/resetRecords')
  // if (!after) {
  //   mappedProcesses = []
  //   store.dispatch('realisations/setRecords', { records: [] })
  //   //store.dispatch('realisations/resetRecords')
  // }

  const api = await fetch('/api/processlist', { // TODO: fix this...was processlist, but that endpoint is not filtering on CPO
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      processType, code, bbox, after
    })
  }).catch(err => console.log(err))

  if (!api.ok) {
    throw new Error(`Getting ${processType} processes failed!`)
  }

  const response = await api.json()

  counts.total = response.data.count
  counts.current += response.data.records.length
  store.dispatch('processes/setCounts', { counts });

  mapProcesses({ processType, processes: response.data.records })

  if (response.data.after) {
    return await fetchProcessesByType({ token, processType, code, bbox, after: response.data.after })
  }

  if (isRVB) {
    // Currently only relavant for RVB raporting pages //
    store.dispatch('processes/setProcessTableRecords', { records: mappedProcesses, processType })
  }

  counts.total = 0
  counts.current = 0

  if (!code) {
    mappedProcesses = []
  }

  return mappedProcesses
}

export async function fetchAssetByLocationId ({ token, locationId }) {
  const api = await fetch('/api/assets', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      locationId
    })
  })
  if (!api.ok) {
    throw new Error('failed')
  }

  const response = await api.json()

  store.dispatch('processes/setSelectedAsset', { asset: response.data.asset })
  return response.data
}

export async function fetchAssetByUuid ({ uuid, projection }) {
  if (!uuid) return

  const queryString = projection
    ? `?${new URLSearchParams([...Object.entries(projection)]).toString()}`
    : ''

  const api = await fetch(`${process.env.VUE_APP_AWS_API_BASE_URL}/assets/${uuid}${queryString}`, {
    method: 'GET',
    headers: {
      'x-api-key': process.env.VUE_APP_AWS_API_KEY,
    },
  })
  if (! api.ok) {
    throw new Error('server error')
  }

  return await api.json()
}

export async function updateProcess ({ token, process }) {
  const api = await fetch('/api/process_update', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      process
    })
  })
  if (!api.ok) {
    throw new Error('Could not update process!')
  }

  const response = await api.json()

  return response.data.record
}

export async function updateProcessField ({ token, process, field }) {
  const api = await fetch('/api/process_update', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      process, field
    })
  })
  if (!api.ok) {
    throw new Error('Could not update process!')
  }

  const response = await api.json()

  return response.data.record
}

const setDataFromRealisationProcess = (response, processType) => {
  const process = response.data.record
  process.realisationProcessData = JSON.parse(JSON.stringify(process))
  process.realisationProcessData.ref = process._id
  process.realisationCategory = process.category
  process.processType = processType

  const realisationProcessData = process.realisationProcessData

  const rpLocation = realisationProcessData.process

  const data = {
    processType: process.processType,
    realisationProcessData,
    realisationCategory: process.category,
    uuid: '',
    MunicipalityCode: realisationProcessData.MunicipalityCode,
    process: {
      Municipality: realisationProcessData.MunicipalityCode,
      ChargePointOperator: rpLocation.ChargePointOperator,
      GridOperator: rpLocation.GridOperator,
      Contractor: rpLocation.Contractor
    },
    locationId: realisationProcessData.locationId
  }

  return data
}

// eslint-disable-next-line no-unused-vars
const setDataFromAsset = (asset, processType) => {
  const ChargePointOperator = store.getters['tenant/getTenant'].tenantName
  const municipalityOptions = store.getters['tenant/getMunicipalityOptions']
  const MunicipalityCode = municipalityOptions.find(mun => mun.text === asset.municipality)?.value
  const manualProcess = asset.processes.at(-1)
  const gridOperatorAddress = asset.editData.gridOperatorAddress || null
  const manualProcessType = store.getters['tenant/getProcessTypes'].find(process => process.value === asset.baseType)
  const { latitude, longitude } = asset.editData.coordinates

  // TEMP fix for "import assets not updating location object" until the real solution is done //
  // asset.locationId (string) is updated properly but the location (Object) is not //
  const location = {
    year: Number(asset.locationId.substring(0, 4)),
    counter: Number(asset.locationId.substring(4, 10))
  }
  location.full = `${location.year}${location.counter.toString().padStart(6, '0')}`
  //

  const realisationProcessData = {
    processType: manualProcessType, // manual, import
    realisationCategory: 'request',
    uuid: '',
    MunicipalityCode,
    process: {
      Municipality: MunicipalityCode,
      ChargePointOperator,
      GridOperator: asset.gridOperator,
      Contractor: asset.contractor || '',
      Location: {
        chargingpointUuid: null,
        chargingpointStatus: null,
        StreetName: asset.street,
        HouseNumber: asset.number,
        HouseNumberSuffix: '',
        PostalCode: asset.postalCode,
        CityName: asset.city,
        Province: '',
        Country: 'Netherlands',
        Latitude: latitude,
        Longitude: longitude,
        AdditionalCoordinates: []
      },
      CPOAdvice: {
        AdditionalCostDescription: '',
        AdditionalCostDescriptionContractor: '',
        PowerType: manualProcess.powerType,
        CPOAdvice: '',
        CPOComments: '',
        ChargingStationVersion: manualProcess.chargingStationVersion
      },
      ParkingSpots: {
        Type: 'station',
        NumberOfChargingStations: 1,
        NumberOfParkingSpots: 1,
        Identifiers: []
      },
      GridConnection: {
        RequestDate: '',
        GridOperatorNumber: asset.gridOperatorNumber,
        ConnectionValue: asset.gridConnectionValue,
        Address: gridOperatorAddress
      },
      PlannedRealisation: {
        PlannedDate: '',
        Permit: 'nvt'
      },
      DateOfCommissioning: {
        DateOfCommissioning: '',
        DateOfEnergyConnection: '',
        EAN: asset.EAN
      },
      Docs: {
        SideView: [],
        TopView: [],
      },
      FinUnit: asset.finUnit,
    },
    locationId: location,
    Docs: {
      LocationProposition: [],
      ChangeRequest: [],
      StreetCabinet: [],
      ParkingSpots: [],
      SideView: [],
      TopView: [],
      DeliveryDocumentation: []
    }
  }

  const data = {
    processType,
    realisationProcessData,
    realisationCategory: 'request',
    uuid: '',
    MunicipalityCode,
    process: realisationProcessData.process,
    locationId: realisationProcessData.locationId
  }

  return data
}
